const moneyUtils = require('../common/utils/moneyUtils');
const { default: getFrontConfig } = require('../common/getFrontConfig');
const bottomSheet = require('../components/bottomSheet');
const installmentHelpers = require('../adyen/checkout/installments');

const FRONT_CONFIG = getFrontConfig();

/**
 * If the site Tax Policy is NET
 * and the order has taxes,
 * updates tax messages
 * @param {string} totalTax
 */
function updateTaxMessages(totalTax) {
  const { isTaxPolicyNet } = FRONT_CONFIG;
  const taxes = moneyUtils.getNumericValue(totalTax);

  if (isTaxPolicyNet && taxes === null) {
    $('.tax-total-container')?.addClass('d-none');
    $('.grand-total-container__taxMsg')?.removeClass('d-none');

    // Update checkout tax message above Payment form
    $('.payment-form__tax-message')?.addClass('d-none');
  } else if (isTaxPolicyNet) {
    const taxTotalPrice = $('.tax-total-container__price');
    if (taxTotalPrice.length > 0) {
      taxTotalPrice.html(totalTax);
    }

    $('.tax-total-container')?.removeClass('d-none');
    $('.grand-total-container__taxMsg')?.addClass('d-none');

    // Update checkout tax message above Payment form
    const paymentFormTaxInfoMessage = document.querySelector('.payment-form__tax-message');
    if (paymentFormTaxInfoMessage) {
      paymentFormTaxInfoMessage.classList.remove('d-none');
      paymentFormTaxInfoMessage.querySelector('.tax-info-message__total').innerHTML = totalTax;
    }
  }
}

/**
 * Updates checkout summary promotions row for given container
 * @param {JQuery} container - promotions container
 * @param {object[]} promotions - promotions data
 * @param {string} promotions.name - promotion name
 * @param {object} promotions.basePrice - promotion base price
 * @param {string} promotions.basePrice.formatted - promotion formatted base price
 */
function updatePromotions(container, promotions) {
  container.empty();
  promotions.forEach((item) => {
    // Main container
    const rowDiscount = document.createElement('div');
    rowDiscount.classList.add(
      'row',
      'leading-lines',
      'order-discount',
      'totals__total',
    );

    // Promo naming
    const nameRowDiscountContainer = document.createElement('div');
    nameRowDiscountContainer.classList.add('start-lines');
    const nameRowDiscountParagraph = document.createElement('p');
    nameRowDiscountParagraph.classList.add('order-receipt-label');
    nameRowDiscountParagraph.innerHTML = `<span>${item.name}</span>`;
    nameRowDiscountContainer.append(nameRowDiscountParagraph);
    rowDiscount.append(nameRowDiscountContainer);

    // discount total amount
    const valueRowDiscountContainer = document.createElement('div');
    valueRowDiscountContainer.classList.add('end-lines');
    const valueRowDiscountParagraph = document.createElement('p');
    valueRowDiscountParagraph.classList.add('order-receipt-value');
    const spanRowDiscountParagraph = document.createElement('span');
    spanRowDiscountParagraph.classList.add(
      'order-discount-total',
      'price-currency',
    );
    spanRowDiscountParagraph.textContent = `- ${item.basePrice.formatted}`;
    valueRowDiscountParagraph.append(spanRowDiscountParagraph);
    valueRowDiscountContainer.append(valueRowDiscountParagraph);
    rowDiscount.append(valueRowDiscountContainer);

    container.append(rowDiscount);
  });
}

/**
 * Updates the productLineItems & shippingn promotion rows in cart totals
 * @param {object} totals - Cart totals object
 * @param {object} totals.appliedPromotions - Cart productLineItem applied promotions object
 * @param {object} totals.shippingAppliedPromotions - Cart shipping applied promotions object
 */
function updatePromotionRows(totals) {
  const productLineItemsPromotionsContainer = $('.promotion-discount-container');
  updatePromotions(productLineItemsPromotionsContainer, totals.appliedPromotions);
  const shippingPromotionsContainer = $('.promotion-discount-container--shipping');
  updatePromotions(shippingPromotionsContainer, totals.shippingAppliedPromotions);
}

/**
 * updates the totals summary
 * @param {Array} totals - the totals data
 */
function updateTotals(totals) {
  const $totalsBlock = $('.totals');
  const $grandTotalContainers = $('.grand-total-container');
  const previousGrandTotal = $('.grand-total', $grandTotalContainers).attr('data-value');
  $('.shipping-cost', $totalsBlock).text(totals.totalShippingCost);
  $('.sub-total', $totalsBlock).text(totals.subTotal);
  // Also update mobile checkout summary header
  $('.grand-total', $grandTotalContainers).text(totals.grandTotal && totals.grandTotal !== '-' ? totals.grandTotal : totals.netGrandTotal).attr('data-value', totals.floatTotal);

  updatePromotionRows(totals);

  if (totals.grandTotal !== previousGrandTotal) {
    installmentHelpers.updateInstallmentOptions();
  }

  updateTaxMessages(totals.totalTax);
}

function initBottomSheet() {
  bottomSheet.initialize({});
}

/**
 * Updates the order products summary for an order model
 * ignores the update when order and dom elements quantity are the same
 * @param {Order} order - the order model
 */
function updateOrderProductSummaryInformation(order) {
  const domProductsLength = document.querySelectorAll('.cart-content__product-container .product-card').length;
  if (order.items.totalQuantity === domProductsLength) {
    return;
  }

  const $productSummary = $('<div />');

  order.shipping.forEach((shipping) => {
    shipping.productLineItems.items.forEach((lineItem) => {
      const productLineItemElement = $(`[data-uuid=${lineItem.UUID}]`);
      $productSummary.append(productLineItemElement);
    });
  });

  const $aproachingDiscount = $('.approaching-discounts');
  $productSummary.append($aproachingDiscount);

  $('.cart-content__product-container').html($productSummary.html());

  const numberOfItemsElement = document.querySelector('.number-of-items');
  if (numberOfItemsElement) {
    const newNumberOfItemsContent = numberOfItemsElement.textContent.replace(
      /\d+/, order.items.totalQuantity,
    );
    numberOfItemsElement.textContent = newNumberOfItemsContent;
  }
}

module.exports = {
  updateTotals,
  updateOrderProductSummaryInformation,
  updateTaxMessages,
  initBottomSheet,
};
